import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../config/ApiConfig';
import ResponsiveShadow from './components/ResponsiveShadow';

function LoginPage() {
  const [login, setLogin] = useState('');
  const [senha, setSenha] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [sessionMessage, setSessionMessage] = useState('');
  const navigate = useNavigate();

  React.useEffect(() => {
    const msg = sessionStorage.getItem('loginRedirectMessage');
    if (msg) setSessionMessage(msg);
  }, []);

  const handleEmailChange = event => setLogin(event.target.value);
  const handlePasswordChange = event => setSenha(event.target.value);

  async function handleSubmit(event) {
    event.preventDefault();
    setIsLoading(true);
    setErrorMessage('');
    try {
      let location = 'Indisponível';
      if (navigator.geolocation) {
        try {
          const pos = await new Promise((res, rej) => navigator.geolocation.getCurrentPosition(res, rej, { timeout: 3000 }));
          location = `${pos.coords.latitude},${pos.coords.longitude}`;
        } catch (_) {}
      }
      const response = await axios.post(
        API_BASE_URL.LOGIN,
        { login, senha, location }
      );
      const { token, usuario, vinculos } = response.data;
      if (!token || !usuario || !vinculos) {
        throw new Error('Dados de login inválidos');
      }

      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(usuario));
      localStorage.setItem('vinculos', JSON.stringify(vinculos));
      localStorage.setItem('login', usuario.login);
      localStorage.setItem('anoBase', new Date().getFullYear().toString());
      sessionStorage.removeItem('loginRedirectMessage');
      window.location.href = '/seleciona_entidade';
    } catch (error) {
      setErrorMessage('Login ou senha incorretos. Tente novamente.');
      console.error('Erro ao buscar itens:', error);
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div
      className="d-flex flex-column min-vh-100"
      style={{
        backgroundImage: `url('/assets/login.png')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        position: 'relative',
      }}
    >
      {/* Overlay escuro para melhor contraste */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.4)',
          zIndex: 0,
        }}
      />

      {/* Conteúdo principal centralizado */}
      <div
        className="d-flex flex-column justify-content-center align-items-center flex-grow-1 py-4"
        style={{ position: 'relative', zIndex: 1 }}
      >
        <div
          style={{
            width: '100%',
            maxWidth: '420px',
            margin: '0 auto',
            padding: '0 20px',
          }}
        >
          {/* Logo/Brand Section */}
          <div className="text-center mb-4">
            <h2
              style={{
                color: 'white',
                fontWeight: '700',
                fontSize: '2rem',
                marginBottom: '0.5rem',
                textShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
              }}
            >
              GCONT
            </h2>
            <p
              style={{
                color: 'rgba(255, 255, 255, 0.9)',
                fontSize: '1rem',
                margin: 0,
              }}
            >
              Sistema de Gestão de Contratos
            </p>
          </div>

          {/* Card de Login */}
          <div
            style={{
              background: 'rgba(255, 255, 255, 0.95)',
              backdropFilter: 'blur(20px)',
              borderRadius: '24px',
              padding: '40px',
              boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
              border: '1px solid rgba(255, 255, 255, 0.3)',
            }}
          >
            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label
                  style={{
                    fontSize: '0.875rem',
                    fontWeight: '600',
                    color: '#4a5568',
                    marginBottom: '0.5rem',
                    display: 'block',
                  }}
                >
                  Usuário
                </label>
                <div style={{ position: 'relative' }}>
                  <i
                    className="bi bi-person-fill"
                    style={{
                      position: 'absolute',
                      left: '16px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      color: '#a0aec0',
                      fontSize: '1.1rem',
                    }}
                  />
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Digite seu usuário"
                    value={login}
                    onChange={handleEmailChange}
                    required
                    style={{
                      fontSize: '1rem',
                      padding: '14px 16px 14px 45px',
                      borderRadius: '12px',
                      border: '2px solid #e2e8f0',
                      transition: 'all 0.3s ease',
                    }}
                    onFocus={e => {
                      e.target.style.borderColor = '#667eea';
                      e.target.style.boxShadow =
                        '0 0 0 3px rgba(102, 126, 234, 0.1)';
                    }}
                    onBlur={e => {
                      e.target.style.borderColor = '#e2e8f0';
                      e.target.style.boxShadow = 'none';
                    }}
                  />
                </div>
              </div>

              <div className="mb-4">
                <label
                  style={{
                    fontSize: '0.875rem',
                    fontWeight: '600',
                    color: '#4a5568',
                    marginBottom: '0.5rem',
                    display: 'block',
                  }}
                >
                  Senha
                </label>
                <div style={{ position: 'relative' }}>
                  <i
                    className="bi bi-lock-fill"
                    style={{
                      position: 'absolute',
                      left: '16px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      color: '#a0aec0',
                      fontSize: '1.1rem',
                    }}
                  />
                  <input
                    type={showPassword ? 'text' : 'password'}
                    className="form-control"
                    placeholder="Digite sua senha"
                    value={senha}
                    onChange={handlePasswordChange}
                    required
                    style={{
                      fontSize: '1rem',
                      padding: '14px 45px 14px 45px',
                      borderRadius: '12px',
                      border: '2px solid #e2e8f0',
                      transition: 'all 0.3s ease',
                    }}
                    onFocus={e => {
                      e.target.style.borderColor = '#667eea';
                      e.target.style.boxShadow =
                        '0 0 0 3px rgba(102, 126, 234, 0.1)';
                    }}
                    onBlur={e => {
                      e.target.style.borderColor = '#e2e8f0';
                      e.target.style.boxShadow = 'none';
                    }}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    tabIndex={-1}
                    aria-label={showPassword ? 'Esconder senha' : 'Mostrar senha'}
                    style={{
                      position: 'absolute',
                      right: '12px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      background: 'none',
                      border: 'none',
                      color: '#a0aec0',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: '4px',
                      borderRadius: '6px',
                      transition: 'color 0.2s',
                    }}
                    onMouseEnter={e => { e.target.style.color = '#4a5568'; }}
                    onMouseLeave={e => { e.target.style.color = '#a0aec0'; }}
                  >
                    {showPassword ? (
                      <i className="bi bi-eye-slash-fill" style={{ fontSize: '1.1rem' }} />
                    ) : (
                      <i className="bi bi-eye-fill" style={{ fontSize: '1.1rem' }} />
                    )}
                  </button>
                </div>
              </div>

              {sessionMessage && (
                <div
                  className="alert alert-warning d-flex align-items-start gap-2"
                  role="alert"
                  style={{
                    fontSize: '0.875rem',
                    borderRadius: '12px',
                    padding: '12px 16px',
                    marginBottom: '1.5rem',
                  }}
                >
                  <i className="bi bi-exclamation-triangle-fill flex-shrink-0 mt-1" />
                  <span>{sessionMessage}</span>
                </div>
              )}
              {errorMessage && (
                <div
                  className="alert alert-danger"
                  role="alert"
                  style={{
                    fontSize: '0.875rem',
                    borderRadius: '12px',
                    padding: '12px 16px',
                    marginBottom: '1.5rem',
                    border: 'none',
                    background: 'linear-gradient(135deg, #fee 0%, #fdd 100%)',
                    color: '#c53030',
                  }}
                >
                  <i className="bi bi-exclamation-circle-fill me-2" />
                  {errorMessage}
                </div>
              )}

              <button
                type="submit"
                className="btn w-100"
                disabled={isLoading}
                style={{
                  fontSize: '1rem',
                  fontWeight: '600',
                  padding: '14px',
                  borderRadius: '12px',
                  border: 'none',
                  background:
                    'linear-gradient(135deg, rgb(7, 29, 65) 0%, rgba(29, 100, 216, 1) 100%)',
                  color: 'white',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
                }}
                onMouseEnter={e => {
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow =
                    '0 6px 20px rgba(102, 126, 234, 0.5)';
                }}
                onMouseLeave={e => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow =
                    '0 4px 15px rgba(102, 126, 234, 0.4)';
                }}
              >
                {isLoading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                    Entrando...
                  </>
                ) : (
                  <>
                    <i className="bi bi-box-arrow-in-right me-2" />
                    Entrar
                  </>
                )}
              </button>
            </form>

            <div className="text-end mb-2" style={{ marginTop: '0.5rem' }}>
              <button
                type="button"
                className="btn btn-link p-0"
                style={{ fontSize: '0.85rem', textDecoration: 'none', color: '#1e3a8a' }}
                onClick={() => navigate('/recuperar-senha')}
              >
                Esqueci minha senha
              </button>
            </div>
          </div>

          {/* Footer */}
          <div className="text-center mt-4">
            <p
              style={{
                color: 'rgba(255, 255, 255, 0.8)',
                fontSize: '0.875rem',
                margin: 0,
              }}
            >
              © 2025 GCONT. Todos os direitos reservados.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
